import { NgModule } from '@angular/core';
import { KrakenSpinnerComponent } from './kraken-spinner.component';
import { CommonModule } from '@angular/common';


@NgModule({
  declarations: [
    KrakenSpinnerComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    KrakenSpinnerComponent
  ]
})
export class KrakenSpinnerModule { }
